import { MENU_GROUP } from '@wwe-portal/web/utils/constants/menu';
import { createStore, StoreApi, useStore } from 'zustand';

interface LayoutState {
  sidebar: 'right' | 'left' | 'none';
  menuGroupOpen: Set<string>;
  scrollOffset: number | undefined;

  setMenuGroupOpen: (menuGroup: string[]) => void;
  openMenuGroup: (menuGroup: string) => void;
  closeMenuGroup: (menuGroup: string) => void;

  setSidebar: (sidebar: 'right' | 'left' | 'none') => void;
  setScrollOffset: (scrollOffset: number) => void;
}

let storeApi: StoreApi<LayoutState> | undefined;

export const getLayoutStore = () => {
  if (!storeApi) {
    storeApi = createStore<LayoutState>((set) => ({
      sidebar: 'none',
      scrollOffset: 0,
      menuGroupOpen: new Set<string>(Object.values(MENU_GROUP)),
      setMenuGroupOpen: (menuGroup) =>
        set({ menuGroupOpen: new Set(menuGroup) }),
      openMenuGroup: (menuGroup) =>
        set((state) => {
          const newSet = new Set(state.menuGroupOpen);
          newSet.add(menuGroup);
          return { menuGroupOpen: newSet };
        }),
      closeMenuGroup: (menuGroup) =>
        set((state) => {
          const newSet = new Set(state.menuGroupOpen);
          newSet.delete(menuGroup);
          return { menuGroupOpen: newSet };
        }),
      setSidebar: (sidebar) => set({ sidebar }),
      setScrollOffset: (scrollOffset) => set({ scrollOffset }),
    }));
  }

  return storeApi;
};

export const useLayoutStore = <T>(selector: (state: LayoutState) => T) => {
  return useStore(getLayoutStore(), selector);
};

export const useMenuState = () => {
  return useLayoutStore((state) => ({
    menuGroupOpen: state.menuGroupOpen,
    openMenuGroup: state.openMenuGroup,
    closeMenuGroup: state.closeMenuGroup,
  }));
};

export const useScrollOffset = () => {
  return useLayoutStore((state) => state.scrollOffset);
};
